import React, { useState } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";


type EventMapLocationProps = {
    lat: number;
    lng: number;
    address: string;
};

const containerStyle = {
    width: "100%",
    height: "400px",
};

const EventMapLocation: React.FC<EventMapLocationProps> = ({ lat, lng, address }) => {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <GoogleMap mapContainerStyle={containerStyle} center={{ lat, lng }} zoom={14}>

            <Marker position={{ lat, lng }} onClick={() => setIsOpen(true)} />
            {isOpen && (
                <InfoWindow position={{ lat, lng }} onCloseClick={() => setIsOpen(false)}>
                    <div>
                        <strong>Event Location</strong>
                        <p>{address}</p>
                    </div>
                </InfoWindow>
            )}
        </GoogleMap>
    );
};

export default EventMapLocation;